import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import toast, { Toaster } from "react-hot-toast";
import * as services from "./../services/saleng";
import { jwtDecode } from "jwt-decode";
import logo from "../images/scrapyard.svg";

const schema = yup.object().shape({
  username: yup.string().required("Please enter username"),
  password: yup
    .string()
    .min(8, "Password must be at least 8 characters")
    .max(20, "Password must not exceed 20 characters")
    .notOneOf(
      [yup.ref("username"), null],
      "Password must not be the same as your username"
    )
    .required("Please enter password"),
});

export default function Login() {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      username: "",
      password: "",
    },
  });

  const onSubmitNew = async (data) => {
    const payload = {
      username: data.username,
      password: data.password,
    };

    try {
      const greenResponse = await services.loginShop(payload);
      const greenData = greenResponse.data;
      if (!greenData.success) {
        toast.error(greenData.error || "Something went wrong");
        return;
      }
      // Extract and store the access token
      const { accessToken } = greenData.data;
      localStorage.setItem("accessToken", accessToken);

      if (accessToken) {
        var decoded = jwtDecode(accessToken);
        var shopId = decoded.id;
        localStorage.setItem("branchId", JSON.stringify(decoded?.branchId));
      }
      const shopResponse = await services.getShop(shopId);
      const shopData = shopResponse.data.data;
      if (shopData) {
        console.log("Shop data retrieved successfully.");
        navigate("/");
        return;
      }
      navigate("/");
    } catch (error) {
      // Handle errors (both login and shop-related)
      toast.error(error?.response?.data?.error || "Something went wrong");
    }
  };

  return (
    <div 
      className="flex items-center justify-center min-h-screen bg-gradient-to-br from-[#F0FDF4] to-[#DCFCE7]"
      style={{ fontFamily: '"IBM Plex Sans Thai", serif' }}
    >
      <Toaster />
      <div 
        className="w-full max-w-md p-8 md:p-10 space-y-6 bg-white shadow-xl rounded-3xl transform transition-all duration-500 ease-in-out hover:shadow-green-200"
        style={{ animation: 'fadeIn 0.6s ease-out' }}
      >
        <div className="flex flex-col items-center">
            <div className="mb-6 transform hover:scale-105 transition-transform duration-300">
                <img
                src={logo}
                alt="logo"
                style={{ width: "350px", height: "auto" }}
                className="drop-shadow-md"
                />
            </div>
            <div className="flex flex-col items-center gap-1 mb-8">
                <h1 className="text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#185519] to-[#2E8B57] tracking-wider">
                    POS
                </h1>
                <p className="text-gray-500 font-medium">
                    ระบบจัดการหน้าร้าน
                </p>
            </div>
        </div>

        <form onSubmit={handleSubmit(onSubmitNew)} className="space-y-6">
          <div className="space-y-2">
            <label htmlFor="username" className="text-sm font-bold text-gray-700 ml-1 block">
              ชื่อผู้ใช้
            </label>
            <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg className="h-5 w-5 text-gray-400 group-focus-within:text-[#185519] transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                </div>
                <input
                id="username"
                className="w-full pl-10 pr-3 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#185519]/20 focus:border-[#185519] transition-all duration-200 bg-gray-50 focus:bg-white"
                type="text"
                placeholder="ระบุชื่อผู้ใช้ของคุณ"
                {...register("username")}
                />
            </div>
            {errors?.username && (
              <p className="text-red-500 text-xs pl-1 font-medium animate-pulse">
                {errors.username?.message}
              </p>
            )}
          </div>

          <div className="space-y-2">
            <label htmlFor="password" className="text-sm font-bold text-gray-700 ml-1 block">
              รหัสผ่าน
            </label>
            <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <svg className="h-5 w-5 text-gray-400 group-focus-within:text-[#185519] transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                </div>
                <input
                id="password"
                className="w-full pl-10 pr-3 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#185519]/20 focus:border-[#185519] transition-all duration-200 bg-gray-50 focus:bg-white"
                type="password"
                placeholder="ระบุรหัสผ่านของคุณ"
                {...register("password")}
                />
            </div>
            {errors?.password && (
              <p className="text-red-500 text-xs pl-1 font-medium animate-pulse">
                {errors.password?.message}
              </p>
            )}
          </div>

          <div className="pt-4">
            <button
              className="w-full px-4 py-3.5 text-white font-bold rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 active:scale-95"
              type="submit"
              style={{ 
                  background: "linear-gradient(135deg, #185519 0%, #2E8B57 100%)" 
              }}
            >
              เข้าสู่ระบบ
            </button>
          </div>
        </form>
      </div>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
